import Location from "../../hooks/Location"
import QRCode from "react-qr-code";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import printIcon from "../../images/icons/print-icon.png"
import arrowLeftIcon from "../../images/icons/arrow-left-icon.png"
import { useHistory, useLocation } from "react-router-dom";
import { getLetterPath, getQrcodeBackLink, getQrcodeLanguage, getQrcodeRoute, getQrcodeValue } from "./qrcodeHelpers";
import { useFirestoreGeneral } from "../../firebase/useFirestore";
import qrcodeSubject from "./qrcodeSubject";

/**
 * @template T
 * @param {Array<T> | string | undefined} docs - Hookuitkomst; '' = nog aan het laden
 * @param {string} id
 * @returns {T | undefined}
 */
const findById = (docs, id) => (Array.isArray(docs) ? docs.find((doc) => doc.ID === id) : undefined)

const Qrcode = () => {

    // Hooks
    const history = useHistory()
    // De instellingen die deze deellink uitzet (`?uit=…`) gaan mee in de
    // QR-code en naar de brief.
    const { search } = useLocation()

    // Url parameters
    const client = Location()[1]
    const questionnaire = Location()[3]
    const measureMomentID = Location()[4]
    const researchID = Location()[5]
    const persona = Location()[6]
    const route = getQrcodeRoute(Location())
    const languageCode = getQrcodeLanguage(Location())

    // Bij welke activiteit, welk formulier of welk onderzoek hoort deze code?
    // Alleen lezen wat bij deze soort hoort; '' slaat de query over
    // (testronde 2026-10-28, Fatima B1).
    const isResearch = route === 'research'
    const researches = useFirestoreGeneral('Research', 'ID', (isResearch && researchID) || '')
    const moments = useFirestoreGeneral('MeasureMoments', 'ID', (isResearch && measureMomentID) || '')
    const intakeForms = useFirestoreGeneral('IntakeForms', 'ID', (route === 'intakeform' && questionnaire) || '')
    const eventForms = useFirestoreGeneral('EventForms', 'ID', (route === 'event' && questionnaire) || '')
    const activityID = findById(eventForms, questionnaire)?.ActivityID || ''
    const activities = useFirestoreGeneral('Activities', 'ID', activityID)
    const subject = qrcodeSubject({
        route,
        research: findById(researches, researchID),
        moment: findById(moments, measureMomentID),
        intakeForm: findById(intakeForms, questionnaire),
        activity: findById(activities, activityID),
    })

    // Kale QR-code of QR-code in een brief: bij elk onderzoek en elke output
    // (registratieformulier), voor elke organisatie — er is altijd een
    // standaardbrief (defaultLetterTemplates).
    // AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md
    const letterPath = getLetterPath({
        client,
        questionnaire,
        measureMomentID,
        researchID,
        persona,
        route,
        languageCode,
        search,
    })
    const qrValue = getQrcodeValue({
        host: window.location.hostname,
        client,
        questionnaire,
        measureMomentID,
        researchID,
        persona,
        route,
        languageCode,
        search,
    })

  return (
    <div className="main">
        <div className="main-container">
            <div className="print-go-back-container" 
            onClick={() => history.push(getQrcodeBackLink({
              client,
              questionnaire,
              measureMomentID,
              researchID,
              persona,
              route,
              search,
            }))}>
                <img src={arrowLeftIcon}/>
                <p>Terug</p>
            </div>
            <div className="qrcode-actions">
                <div className="print-icon-container" onClick={() => window.print()}>
                    <img src={printIcon} alt="print icon" className="print-icon" />
                    <p>Print QRcode</p>
                </div>
                {letterPath && (
                    <div className="print-icon-container" onClick={() => history.push(letterPath)}>
                        <MailOutlinedIcon className="print-icon" />
                        <p>Brief maken</p>
                    </div>
                )}
            </div>
            <div className="print-content-container">
                {subject && <h1 className="qrcode-subject">{subject}</h1>}
                <QRCode value={qrValue} />
                {/* Leesbaar onder de code, zoals op de brief (testronde 2026-10-12, B6). */}
                {/* Ook aan te klikken: zo kun je het formulier zelf openen om het
                    in te vullen of te bekijken (testronde 2026-10-28, B1). */}
                <p className="letter-link">
                    <a href={qrValue} target="_blank" rel="noopener noreferrer">{qrValue}</a>
                </p>
            </div>
        </div>
    </div>
  )
}

export default Qrcode
